<div class="dynamic-field form-input" [ngClass]="moreClass" [formGroup]="localformGroup" [ngSwitch]="type"
  *ngIf="shouldDisplayField()">
  <!---->
  <!--CHECKBOX-->
  <!---->

  <div class="custom-control custom-checkbox mb-2" *ngSwitchCase="'checkbox'">
    <div [hidden]="hidden">
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <input class="custom-control-input user-select-none" [id]="idFromName"
        [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" type="checkbox" role="checkbox"
        [attr.placeholder]="placeholder" [label]="label" [section]="prefixId" [subSectionId]="subSectionId"
        [fieldId]="this.field.id" (change)="endOfFocus()"/>

      <label class="custom-control-label control-label user-select-none" [for]="idFromName" [translate]="label"></label>
    </div>
  </div>
  <!---->
  <!--EMAIL-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'email'">
    <div [hidden]="hidden">
      <label *ngIf="label"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible')}"
        [for]="idFromName" [translate]="label"></label>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-container">
        <div class="input-wrapper">
          <input class="form-control" [value]="value" type="email" [attr.placeholder]="placeholder"
            [fieldId]="this.field.id" [attr.disabled]="isEformTable===true? true : null" [formControlName]="name"
            [label]="label" [section]="prefixId" [subSectionId]="subSectionId"
            [ngClass]="{ 'is-invalid': hasError() }" (change)="endOfFocus()" />
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!---->
  <!--DATE-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'date'">
    <div *ngIf="!hidden" [hidden]="hidden">
      <label *ngIf="label"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <input class="form-control" [id]="idFromName" [value]="value" type="date" [attr.placeholder]="placeholder"
        [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" [fieldId]="this.field.id"
        [ngClass]="{ 'is-invalid': hasError() }" [label]="label" [section]="prefixId" max="9999-12-31"
        [subSectionId]="subSectionId" (change)="endOfFocus()"/>
      <label hidden="true" [for]="name + '_timestamp'">timestamp</label>
      <input hidden="true" class="form-control" [id]="name + '_timestamp'" [value]="timestamp" type="date"
        [attr.disabled]="isEformTable===true? true : null" [formControlName]="name + '_timestamp'" max="9999-12-31"
        [fieldId]="this.field.id" [label]="label" [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()" />
      <button *ngIf="field._repeatable && !isEformTable"
        [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
        title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
      <button *ngIf="field._repeatable  && !isEformTable"
        [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
        title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
      <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
        info
      </mat-icon>
    </div>
  </div>

  <!---->
  <!--DATETIME-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'datetime'">
    <div *ngIf="!hidden" [hidden]="hidden">
      <label *ngIf="label"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <input type="datetime-local" [attr.placeholder]="placeholder" [attr.disabled]="isEformTable===true? true : null"
        [formControlName]="name" [ngClass]="{ 'is-invalid': hasError() }" [label]="label" (change)="endOfFocus()"
        max="9999-12-31T23:59" [section]="prefixId" [subSectionId]="subSectionId" [fieldId]="this.field.id" />
      <input hidden="true" class="form-control" [id]="name + '_timestamp'" [value]="timestamp" type="datetime-local"
        [attr.disabled]="isEformTable===true? true : null" [formControlName]="name + '_timestamp'"
        max="9999-12-31T23:59" [fieldId]="this.field.id" [label]="label" [section]="prefixId"
        [subSectionId]="subSectionId" (change)="endOfFocus()" />
      <button *ngIf="field._repeatable && !isEformTable"
        [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
        title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
      <button *ngIf="field._repeatable && !isEformTable"
        [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
        title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
      <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
        info
      </mat-icon>
    </div>
  </div>

    <!---->
  <!--TIME-->
  <!---->

  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'time'">
    <div *ngIf="!hidden">
      <label *ngIf="label && !hidden && !isEformTable"
        [ngClass]="{ 'required': isRequired(), 'control-label':true, 'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label">
      </label>
      <span *ngIf="this.field.id && !hidden && !isEformTable"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-container">
        <div class="input-wrapper">
          <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName" [section]="prefixId"
            (change)="endOfFocus()" [subSectionId]="subSectionId" [value]="value" type="time" step="1"
            [attr.placeholder]="placeholder" *ngIf="!hidden" [fieldId]="this.field.id"
            [attr.disabled]="isEformTable===true? true : null" [label]="label" [formControlName]="name"
            (keydown)="timeformat($event)" />
          <button *ngIf="field._repeatable && !field.secondaryElement && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && field.secondaryElement && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle && !hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!---->
  <!--money-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'money'">
    <div *ngIf="!hidden && !isEformTable" [hidden]="hidden">
      <label *ngIf="label"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-group" [ngClass]="{ 'is-invalid': hasError() }" [hidden]="hidden">
        <input class="form-control with-append" [id]="idFromName" [fieldId]="this.field.id" [value]="value"
          type="number" [attr.placeholder]="placeholder" [attr.disabled]="isEformTable===true? true : null"
          [formControlName]="name" (focusout)="controlValue($event)" (change)="endOfFocus()" (keydown)="keyDownControl($event)"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" />
        <div class="input-group-append">
          <span class="input-group-text">€</span>
        </div>
        <button *ngIf="field._repeatable  && !isEformTable"
          [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <button *ngIf="field._repeatable && !isEformTable"
          [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
      </div>
    </div>
  </div>

  <!---->
  <!--percentage-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'percentage'">
    <div [hidden]="hidden">
      <label *ngIf="label"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-group" [ngClass]="{ 'is-invalid': hasError() }">
        <input class="form-control with-append" [id]="idFromName" [fieldId]="this.field.id" [value]="value"
          type="number" [attr.placeholder]="placeholder" [attr.disabled]="isEformTable===true? true : null"
          [formControlName]="name" (focusout)="controlValue($event)" (change)="endOfFocus()" (keydown)="keyDownControl($event)"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!---->
  <!--radio-->
  <!---->
  <div class="mb-2" *ngSwitchCase="'radio'">
    <div [hidden]="hidden">
      <div>
        <span *ngIf="label" class="spanBold" [translate]="label"
          [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"></span>
        <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden" class="ml-1"> ({{this.field.id}})</span>
        <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
      </div>
      <span hidden [id]="'span' + name" [class]="type" [attr.data-radiosFAD]="radios|json">{{label}}</span>

      <mat-radio-group class="example-radio-group" [name]="name" [id]="idFromName"
        [disabled]="disabled" [attr.disabled]="isEformTable===true? true : null">
        <mat-radio-button role="radio" class="example-radio-button d-block" *ngFor="let radio of radios"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" [id]="radio.id"
          [value]="radio.value" [translate]="radio.label" [fieldId]="this.field.id"
          [checked]="radio.value === currentCheckedValue" #radioButton (click)="checkState(radioButton)">
          {{ radio.label | translate }}
        </mat-radio-button>
      </mat-radio-group>
      <button *ngIf="field._repeatable && !isEformTable"
        [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
        title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
      <button *ngIf="field._repeatable && !isEformTable"
        [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
        title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
    </div>
  </div>

  <!---->
  <!--number-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'number'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label">
      </label><span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <div class="input-container">
        <div class="input-wrapper">
          <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName"
            [fieldId]="this.field.id" [value]="value" type="number" [attr.placeholder]="placeholder" [hidden]="hidden"
            (focusout)="controlValue($event)" (keydown)="keyDownControl($event)"
            [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" [label]="label"
            [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()" />
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle && !hidden" [hidden]="hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!---->
  <!--autocomplete-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'autocomplete'">
    <div [hidden]="hidden">
      <mat-form-field appearance="none">
        <label *ngIf="label && !hidden" [hidden]="hidden"
          [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
          [for]="idFromName" [translate]="label"></label>
        <span hidden [id]="'span' + name" [class]="type">{{label}}</span>
        <span *ngIf="isParcoursUtilisateur()">
          {{field.parcoursUtilisateur.messageWarning}}
        </span>
        <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName" [value]="value"
          [attr.placeholder]="placeholder" type="text" matInput [hidden]="hidden" [fieldId]="this.field.id"
          [matAutocomplete]="auto" [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" (change)="endOfFocus()"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.code">
            <span>{{ option.code }}</span><span *ngIf="option.libelle != ''"> - </span><span
              *ngIf="option.libelle != ''">{{ option.libelle | translate }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-icon *ngIf="infoBulle && !hidden" [hidden]="hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
        info
      </mat-icon>
    </div>
  </div>

  <!---->
  <!--autocompleteWithStar-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'autocompleteWithStar'">
    <div [hidden]="hidden">
      <div class="preference">
        <label *ngIf="label && !hidden" [hidden]="hidden"
          [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
          [for]="idFromName" [translate]="label"></label>
        <!-- Préfixe 'span' comme pour les autres types : sans lui, ce libellé masqué portait l'id du
             contrôle, que le bandeau d'erreurs cible pour rediriger vers le champ (PRB0054132). -->
        <span hidden [id]="'span' + name" [class]="type">{{label}}</span>
        <span *ngIf="isParcoursUtilisateur()">
          {{field.parcoursUtilisateur.messageWarning}}
        </span>
        <app-star-preference *ngIf="isPrefActivated" class="ml-1" preferenceType={{preferenceType}}
          (preferenceSelected)="chargeDonneePreference($event)">
        </app-star-preference>
      </div>
      <mat-form-field appearance="none">
        <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName" [value]="value"
          [attr.placeholder]="placeholder" type="text" matInput [hidden]="hidden" [matAutocomplete]="auto"
          [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" [label]="label"
          [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()" />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <button *ngIf="field._repeatable  && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle && !hidden" [hidden]="hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.code">
            <span>{{ option.code }}</span><span *ngIf="option.libelle != ''"> - </span><span
              *ngIf="option.libelle != ''">{{ option.libelle | translate }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <!---->
  <!--List-->
  <!---->

  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'select'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type" [attr.data-typeSelect]="typeSelect">{{label}}</span>

      <div id="select-div" [hidden]="hidden">
        <select
          [attr.disabled]="(isEformTable===true? true : null) || (disabled===true? true : null)"
          [fieldId]="this.field.id" [formControlName]="name" class="form-control" [id]="idFromName"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()"
          (mousedown)="onSelectMouseDown($event)">
          <ng-container *ngIf="options">
            <option *ngFor="let option of options" [value]="option"
              [ngClass]="{ 'translate-missing': translateService.instant(option).includes('La traduction n\'est pas disponible') }">
              {{ option | translate }}
            </option>
          </ng-container>
          <ng-container *ngIf="optionsWithCode">
            <option *ngFor="let option of optionsWithCode" [value]="option?.code">
              {{ option?.libelle | translate }}
            </option>
          </ng-container>
        </select>
        <button *ngIf="field._repeatable  && !isEformTable"
          [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <button *ngIf="field._repeatable  && !isEformTable"
          [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
      </div>
    </div>
  </div>

  <!---->
  <!--ListWithStar-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'listWithStar'">
    <div [hidden]="hidden">
      <div class="preference">
        <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
          [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
          [for]="idFromName" [translate]="label"></label>
        <span class="ml-1" *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
        <span hidden [id]="'span' + name" [class]="type" [attr.data-typeSelect]="typeSelect">{{label}}</span>
        <span *ngIf="isParcoursUtilisateur()">
          {{field.parcoursUtilisateur.messageWarning}}
        </span>
        <app-star-preference [attr.hidden]="(isEformTable===true? true : null)" class="ml-1"
          preferenceType={{preferenceType}} (preferenceSelected)="chargeDonneePreference($event)">
        </app-star-preference>
      </div>
      <div id="select-div">
        <select
          [attr.disabled]="(isEformTable===true? true : null) || disabled"
          [fieldId]="this.field.id" [formControlName]="name" class="form-control" [id]="idFromName"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()"
          (mousedown)="onSelectMouseDown($event)">
          <ng-container *ngIf="options">
            <option *ngFor="let option of options" [value]="option"
              [ngClass]="{ 'translate-missing': translateService.instant(option).includes('La traduction n\'est pas disponible') }">
              {{ option | translate }}
            </option>
          </ng-container>
          <ng-container *ngIf="optionsWithCode">
            <option *ngFor="let option of optionsWithCode" [value]="option.code">
              {{ option.libelle| translate }}
            </option>
          </ng-container>
        </select>
        <button *ngIf="field._repeatable && !isEformTable"
          [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <button *ngIf="field._repeatable && !isEformTable"
          [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
      </div>
    </div>
  </div>

  <!---->
  <!--Chips-->
  <!---->

  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'chips'">
    <div [hidden]="hidden">
      <span hidden [id]="'span' + name" [class]="type" [attr.data-typeChips]="autoCompleteType">{{label}}</span>

      <div class="dropdown ml-95" *ngIf="autoCompleteType === 'TODO'">

        <a aria-expanded="false" aria-haspopup="true" class="horizon" data-toggle="dropdown" href="#"
          id="dropdownMenuLink" role="button">
          <mat-icon>star_border</mat-icon>
        </a>
        <div aria-labelledby="dropdown-menu" class="dropdown-menu">
          <div class="d-flex">
            <mat-icon aria-hidden="false" class="ml-auto">close</mat-icon>
          </div>
          <div *ngFor="let el of preferenceList  | async" aria-labelledby="element1" class="w-100 text-nowrap">
            <a (click)="chargerListe(el)" style="cursor: pointer;">{{el.code}}</a>
          </div>
        </div>

      </div>

      <mat-form-field appearance="none">
        <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
          [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
          [for]="idFromName" [translate]="label"></label>
        <span hidden [id]="'span' + name">{{label}}</span>
        <span *ngIf="isParcoursUtilisateur()">
          {{field.parcoursUtilisateur.messageWarning}}
        </span>
        <mat-chip-list #chipList>
          <!-- Avec autoCompleteType (recherche par code) -->
          <ng-container *ngIf="autoCompleteType !== undefined">
            <mat-chip *ngFor="let selectedOption of selectedOptions" [selectable]="selectedOption.code"
                      [removable]="selectedOption" (removed)="remove(selectedOption.code ? selectedOption.code : selectedOption)">
              {{ selectedOption.libelle || selectedOption }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </ng-container>
          <!-- Sans autoCompleteType -->
          <ng-container *ngIf="autoCompleteType === undefined">
            <mat-chip *ngFor="let selectedOption of selectedOptions" [selectable]="selectedOption"
                      [removable]="selectedOption" (removed)="remove(selectedOption.code ? selectedOption.code : selectedOption)">
              {{ selectedOption.libelle || selectedOption }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </ng-container>
          <input #chipsInput class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName"
            [attr.placeholder]="placeholder" matInput [attr.disabled]="isEformTable===true? true : null"
            [formControlName]="name + '_chips'" [fieldId]="this.field.id" [matAutocomplete]="auto"
            [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)" [label]="label" [section]="prefixId"
            [subSectionId]="subSectionId">
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.code">
            <span *ngIf="isCPV" >{{ option.code }}</span><span *ngIf="option.libelle != '' && isCPV"> - </span><span
              *ngIf="option.libelle != ''">{{ option.libelle | translate }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <!---->
  <!--password-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'password'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ 'required': isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label">
      </label><span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="d-flex flex-row">
        <input class="form-control" [fieldId]="this.field.id" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName"
          [value]="value" [type]="fieldTextType ? 'text' : 'password'" [attr.placeholder]="placeholder"
          [hidden]="hidden" [attr.disabled]="isEformTable===true? true : null" [formControlName]="name"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" />
        <button *ngIf="field._repeatable && !isEformTable"
          [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <button *ngIf="field._repeatable && !isEformTable"
          [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <mat-icon *ngIf="infoBulle && !hidden" [hidden]="hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
        <span class="input-group-text" (click)="toggleFieldTextType()"><em class="fa"
            [ngClass]="{'fa-eye-slash': !fieldTextType,'fa-eye': fieldTextType}"></em></span>
      </div>
    </div>
  </div>

  <!---->
  <!--currency-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'currencyid'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type" [attr.data-typeSelect]="typeSelect">{{label}}</span>

      <div id="select-div" [hidden]="hidden">
        <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName"
            [fieldId]="this.field.id" [value]="value" type="number" [attr.placeholder]="placeholder" [hidden]="hidden"
            (focusout)="controlValue($event)" (keydown)="keyDownControl($event)" (input)="endOfFocus()"
            [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" [label]="label"
            [section]="prefixId" [subSectionId]="subSectionId" />
        <select
          [attr.disabled]="(isEformTable===true? true : null) || (disabled===true? true : null)"
          [fieldId]="this.field.id" [formControlName]="type" class="form-control" [id]="idFromName+'_'+type"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()"
          (mousedown)="onSelectMouseDown($event)">
          <ng-container *ngIf="options">
            <option *ngFor="let option of options" [value]="option"
              [ngClass]="{ 'translate-missing': translateService.instant(option).includes('La traduction n\'est pas disponible') }">
              {{ option | translate }}
            </option>
          </ng-container>
          <ng-container *ngIf="optionsWithCode">
            <option *ngFor="let option of optionsWithCode" [value]="option.code">
              {{ option.libelle| translate }}
            </option>
          </ng-container>
        </select>
        <button *ngIf="field._repeatable && !field.secondaryElement && !isEformTable"
          [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <button *ngIf="field._repeatable && field.secondaryElement && !isEformTable"
          [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
      </div>
    </div>
  </div>

  <!--unitcode-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'unitcode'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type" [attr.data-typeSelect]="typeSelect">{{label}}</span>

      <div id="select-div" [hidden]="hidden">
        <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName"
            [fieldId]="this.field.id" [value]="value" type="number" [attr.placeholder]="placeholder" [hidden]="hidden"
            (focusout)="controlValue($event)" (keydown)="keyDownControl($event)" (input)="endOfFocus()"
            [attr.disabled]="isEformTable===true? true : null" [formControlName]="name" [label]="label"
            [section]="prefixId" [subSectionId]="subSectionId" />
        <select
          [attr.disabled]="(isEformTable===true? true : null) || (disabled===true? true : null)"
          [fieldId]="this.field.id" [formControlName]="type" class="form-control" [id]="idFromName+'_'+type"
          [label]="label" [section]="prefixId" [subSectionId]="subSectionId" (change)="endOfFocus()"
          (mousedown)="onSelectMouseDown($event)">
          <ng-container *ngIf="options">
            <option *ngFor="let option of options" [value]="option"
              [ngClass]="{ 'translate-missing': translateService.instant(option).includes('La traduction n\'est pas disponible') }">
              {{ option | translate }}
            </option>
          </ng-container>
          <ng-container *ngIf="optionsWithCode">
            <option *ngFor="let option of optionsWithCode" [value]="option.code">
              {{ option.libelle| translate }}
            </option>
          </ng-container>
        </select>
        <button *ngIf="field._repeatable && !field.secondaryElement && !isEformTable"
          [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <button *ngIf="field._repeatable && field.secondaryElement && !isEformTable"
          [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
          title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
        <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
          info
        </mat-icon>
      </div>
    </div>
  </div>

  <!---->
  <!-- inputTextWithStar-->
  <!---->

  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'textWithStar'">
    <div [hidden]="hidden">
      <div class="preference">
        <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
          [ngClass]="{ 'required': isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
          [for]="idFromName" [translate]="label">
        </label><span hidden [id]="'span' + name" [class]="type">{{label}}</span>
        <span *ngIf="isParcoursUtilisateur()">
          {{field.parcoursUtilisateur.messageWarning}}
        </span>
        <span class="ml-1" *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
        <span hidden [id]="'span' + name" [class]="type">{{label}}</span>
        <app-star-preference class="ml-1" preferenceType={{preferenceType}}
          (preferenceSelected)="chargeDonneePreference($event)">
        </app-star-preference>
      </div>
      <div class="input-container">
        <div class="input-wrapper">
          <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName" [section]="prefixId"
            (change)="endOfFocus()" [subSectionId]="subSectionId" [value]="value" type="text"
            [attr.placeholder]="placeholder" [hidden]="hidden" [fieldId]="this.field.id"
            [attr.disabled]="isEformTable===true? true : null" [label]="label" [formControlName]="name"
            (keydown)="timeformat($event)" />
          <mat-icon *ngIf="infoBulle && !hidden" [hidden]="hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!---->
  <!--form  array-->
  <!---->
  <div *ngSwitchCase="'arrayEforms'">
    <div [hidden]="hidden">
      <ng-container [formArrayName]="name">
        <div *ngFor="let arrayControl of localformGroup.controls[name].controls;let i = index">
          <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
            [ngClass]="{ 'required': isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
            [for]="idFromName" [translate]="label">
          </label>
          <span *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
          <input [attr.disabled]="isEformTable===true? true : null" [fieldId]="this.field.id" [formControlName]="i"
            [label]="label" [section]="prefixId" [subSectionId]="subSectionId" />
        </div>
      </ng-container>
    </div>
  </div>



  <!---->
  <!--text-multilingual-->
  <!---->
  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'text-multilingual'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ required: isRequired(), 'control-label':true,'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label"></label>
      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-group-append" [hidden]="hidden">
        <span class="input-group-text">FR</span>
        <div class="input-group" [ngClass]="{ 'is-invalid': hasError() }">
          <input class="form-control" [id]="idFromName" [value]="value" [fieldId]="this.field.id" type="text" (change)="endOfFocus()"
            [attr.placeholder]="placeholder" [attr.disabled]="isEformTable===true? true : null" [formControlName]="name"
            [label]="label" [section]="prefixId" [subSectionId]="subSectionId" />
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!---->
  <!--default inputText-->
  <!---->

  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchDefault>
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ 'required': isRequired(), 'control-label':true, 'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label">
      </label>
      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-container">
        <div class="input-wrapper">
          <input class="form-control" [ngClass]="{ 'is-invalid': hasError() }" [id]="idFromName" [section]="prefixId"
            (change)="endOfFocus()" [subSectionId]="subSectionId" [value]="value" type="text"
            [attr.placeholder]="placeholder" [hidden]="hidden" [fieldId]="this.field.id"
            [attr.disabled]="(isEformTable===true? true : null) || (disabled===true? true : null)" [label]="label" [formControlName]="name"
            (keydown)="timeformat($event)" />
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle && !hidden" [hidden]="hidden" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div [ngClass]="isEformTable===true?'':'form-group'" *ngSwitchCase="'date-eform'">
    <div [hidden]="hidden">
      <label *ngIf="label && !hidden && !isEformTable" [hidden]="hidden"
        [ngClass]="{ 'required': isRequired(), 'control-label':true, 'translate-missing': translateService.instant(label).includes('La traduction n\'est pas disponible') }"
        [for]="idFromName" [translate]="label">
      </label>
      <span *ngIf="this.field.id && !hidden && !isEformTable" [hidden]="hidden"> ({{this.field.id}})</span>
      <span hidden [id]="'span' + name" [class]="type">{{label}}</span>

      <div class="input-container">
        <div class="input-wrapper">
          <input class="form-control" type="date" [id]="idFromName" [fieldId]="this.field.id" [formControlName]="name"
            [value]="value" [attr.placeholder]="placeholder" [attr.disabled]="isEformTable===true? true : null"
            [label]="label" [section]="prefixId" [subSectionId]="subSectionId" max="9999-12-31" (change)="endOfFocus()">
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonDupliquerLabel | translate" [translate]="buttonDupliquerLabel" (click)="addField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <button *ngIf="field._repeatable && !isEformTable"
            [value]="buttonSupprimerLabel | translate" [translate]="buttonSupprimerLabel" (click)="removeField()"
            title="Duplicate" class="btn btn-outline-primary ml-2 otherOptions"></button>
          <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent()" aria-hidden="false">
            info
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <!---->
  <!--ERROR SURFACES -->
  <!---->

  <app-form-input-error [activeForm]="parentForm" [type]="type" [name]="name"
    [errorMessage]="errorMessage" [rule]="rule" [eform]="!isFieldEmpty()" [pathElements]="pathElements"
    [localformGroup]="localformGroup" [repeatablePathWithIndex]="repeatablePathWithIndex" [arrayLength]="arrayLength"
    [lastElementArray]="lastElementArray" [index]="index" [field]="field"> </app-form-input-error>

    <p class="messageInfo" *ngIf="isEform && field.parcoursUtilisateur">
      {{field.parcoursUtilisateur.messageWarning}}
    </p>
</div>
